const purple = '#5236AB';

const styles = {
  compactActionButton: {
    p: 0,
    minWidth: 'auto',
  },

  editIcon: {
    color: purple,
  },

  editingRowWhole: {
    backgroundColor: '#F3F0FF',
  },

  blurredRow: {
    filter: 'blur(1px)',
    opacity: 0.7,
    pointerEvents: 'none',
    transition: 'filter 0.2s ease',
  },

  invalidRowStrongRow: {
    backgroundColor: 'rgba(210,47,47,0.10)',
    backgroundImage:
      'linear-gradient(90deg, rgba(210,47,47,0.14) 0%, rgba(210,47,47,0.08) 50%, rgba(210,47,47,0.03) 100%)',
    boxSizing: 'border-box',
    cursor: 'help',
  },

  invalidCellFull: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    backgroundColor: 'rgba(210,47,47,0.36)',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },

  errorCellText: {
    color: '#6b0a0a', 
    fontWeight: 700,
    fontSize: '0.95rem',
    lineHeight: 1.2,
    display: 'block',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    boxSizing: 'border-box',
  },

  issueListBox: {
    maxWidth: 260,
    padding: 0,
    margin: 0,
  },

  issueUl: {
    margin: 0,
    paddingLeft: 14,
  },

  issueLi: {
    listStyle: 'disc',
    marginBottom: 4,
  },

  validationDivider: {
    height: 1,
    backgroundColor: '#F3D6D6',
    margin: '6px 0',
  },

  validationListBox: {
    maxHeight: 200,
    overflowY: 'auto',
    paddingRight: 4,
  },

  validationList: {
    margin: 0,
    paddingLeft: 14,
    color: '#B42318',
    listStyle: 'disc',
  },
};

export default styles;
